export const TOKEN_LOCKER_ABI = [
  { inputs: [], name: 'AlreadyInitialized', type: 'error' },
  { inputs: [], name: 'BelowMinimum', type: 'error' },
  { inputs: [], name: 'ECDSAInvalidSignature', type: 'error' },
  { inputs: [{ internalType: 'uint256', name: 'length', type: 'uint256' }], name: 'ECDSAInvalidSignatureLength', type: 'error' },
  { inputs: [{ internalType: 'bytes32', name: 's', type: 'bytes32' }], name: 'ECDSAInvalidSignatureS', type: 'error' },
  { inputs: [], name: 'InsufficientStake', type: 'error' },
  { inputs: [], name: 'InvalidAmount', type: 'error' },
  { inputs: [], name: 'InvalidNonce', type: 'error' },
  { inputs: [], name: 'InvalidSignature', type: 'error' },
  { inputs: [], name: 'LockTimeNotSupported', type: 'error' },
  { inputs: [], name: 'MarketNotOpen', type: 'error' },
  { inputs: [], name: 'NoStake', type: 'error' },
  { inputs: [], name: 'OnlyPredictMarket', type: 'error' },
  { inputs: [{ internalType: 'address', name: 'token', type: 'address' }], name: 'SafeERC20FailedOperation', type: 'error' },
  { inputs: [], name: 'StillLocked', type: 'error' },
  { inputs: [], name: 'TransferTaxNotSupported', type: 'error' },
  { inputs: [], name: 'Unauthorized', type: 'error' },
  { inputs: [], name: 'ZeroAddress', type: 'error' },
  { inputs: [], name: 'ZeroAmount', type: 'error' },
  {
    anonymous: false, type: 'event', name: 'Locked',
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
      { indexed: false, internalType: 'uint40', name: 'lockStartTime', type: 'uint40' },
      { indexed: false, internalType: 'uint40', name: 'lockEndTime', type: 'uint40' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'PredictMarketOpened',
    inputs: [
      { indexed: false, internalType: 'uint256', name: 'totalLockedAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'memberCount', type: 'uint256' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'TransferFromPredict',
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'address', name: 'predictMarket', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'TransferredToPredictMarket',
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'address', name: 'predictMarket', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'Unlocked',
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
  },
  {
    type: 'function', name: 'allLocks', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    outputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint40', name: 'lockEndTime', type: 'uint40' },
      { internalType: 'uint40', name: 'lockTime', type: 'uint40' },
    ],
  },
  {
    type: 'function', name: 'deadline', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'factory', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'groupLockAmount', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'groupMemberCount', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint40', name: '', type: 'uint40' }],
  },
  {
    type: 'function', name: 'initialize', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'address', name: '_token', type: 'address' },
      { internalType: 'address', name: '_factory', type: 'address' },
      { internalType: 'uint256', name: '_groupLockAmount', type: 'uint256' },
      { internalType: 'uint256', name: '_userMinAmount', type: 'uint256' },
      { internalType: 'uint40', name: '_groupMemberCount', type: 'uint40' },
      { internalType: 'uint256', name: '_deadline', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'isLocked', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
  },
  {
    type: 'function', name: 'isPredictOpen', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
  },
  {
    type: 'function', name: 'isSupportedLockTime', stateMutability: 'view',
    inputs: [{ internalType: 'uint256', name: 'lockDuration', type: 'uint256' }],
    outputs: [{ internalType: 'bool', name: 'isSupported', type: 'bool' }],
  },
  {
    type: 'function', name: 'lock', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'lockPeriod', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'nonces', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'setLockTimeSupport', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'uint256', name: 'lockDuration', type: 'uint256' },
      { internalType: 'bool', name: 'isSupported', type: 'bool' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'token', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'totalLockedAmount', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'transferFromPredict', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'address', name: 'user', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'transferToPredict', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'address', name: 'user', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'nonce', type: 'uint256' },
      { internalType: 'bytes', name: 'signature', type: 'bytes' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'unlock', stateMutability: 'nonpayable',
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    outputs: [],
  },
  {
    type: 'function', name: 'relock', stateMutability: 'nonpayable',
    inputs: [],
    outputs: [],
  },
  {
    type: 'function', name: 'userMinAmount', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
] as const;
